import { Flower2, MapPin, Phone, Clock, MonitorSmartphone, Mail, MessageCircle } from "lucide-react";

export default function SiteFooter({ t }) {
  return (
    <footer className="border-t border-line bg-[#EDE9E1]" data-testid="site-footer">
      <div className="px-6 sm:px-10 lg:px-20 py-16 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <p className="flex items-center gap-2 font-serif text-xl text-ink mb-3">
              <Flower2 className="h-5 w-5 text-sage" /> Elba Rojas
            </p>
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-sage mb-4">{t.role}</p>
            <p className="text-sm leading-relaxed text-stonemute max-w-xs">
              {t.services}
            </p>
          </div>
          <div className="space-y-4 text-sm text-ink/80">
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-sage mb-2">{t.contactTitle}</p>
            <p className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-clay" />
              PH Medical Plaza, Piso 3 · Consultorio 00
            </p>
            <a href="https://wa.me/50762485277" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"
              className="flex items-start gap-3 transition-colors hover:text-sage">
              <MessageCircle className="h-4 w-4 mt-0.5 shrink-0 text-clay" />
              WhatsApp: +507 6248-5277
            </a>
            <p className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 shrink-0 text-clay" />
              {t.phone}
            </p>
            <a href="mailto:elba0917@gmail.com" data-testid="footer-email-link"
              className="flex items-start gap-3 transition-colors hover:text-sage">
              <Mail className="h-4 w-4 mt-0.5 shrink-0 text-clay" />
              elba0917@gmail.com
            </a>
          </div>
          <div className="space-y-4 text-sm text-ink/80">
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-sage mb-2">{t.hoursTitle}</p>
            <p className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 shrink-0 text-clay" />
              {t.hours}
            </p>
            <p className="flex items-start gap-3">
              <MonitorSmartphone className="h-4 w-4 mt-0.5 shrink-0 text-clay" />
              {t.tele}
            </p>
          </div>
        </div>
        <div className="border-t border-line mt-14 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-stonemute max-w-md">
            {t.disclaimer}
          </p>
          <a href="/admin/login" data-testid="admin-access-link"
            className="text-xs uppercase tracking-[0.2em] font-semibold text-stonemute transition-colors hover:text-sage">
            {t.adminLink}
          </a>
        </div>
      </div>
    </footer>
  );
}
